import React from 'react';
import {
  Box,
  Container,
  Flex,
  Heading,
  IconButton,
  Img,
  Link,
  ListItem,
  Text,
  UnorderedList,
} from '@chakra-ui/react';
import { FaLinkedin } from 'react-icons/fa';

// eslint-disable-next-line arrow-body-style
const TheContextFundEcosystemBlog = () => {
  return (
    <>
      {/* members */}
      <Flex
        as="section"
        flexDirection="column"
        overflow="hidden"
        justify="center"
        height={{ xs: '450px', sm: '300px' }}
        minH={{ xs: '450px', sm: '300px' }}
        maxH="450px"
        pos="relative"
      >
        <Img
          pos="absolute"
          objectFit="cover"
          src="/jpg/blogBanner.jpg"
          alt="members-hero"
          height="100%"
          width="100%"
        />
        <Box
          bg="linear-gradient(93.48deg, #00001F 45.8%, #186658 74.6%)"
          pos="absolute"
          height="100%"
          width="100%"
          opacity="0.7"
        />
        <Container
          display="flex"
          as="section"
          maxW="container.xl"
          position="relative"
          zIndex="1"
          flexDirection="column"
        >
          <Flex
            alignItems={{ xs: 'flex-start', md: 'flex-start' }}
            justifyContent="center"
            columnGap="24px"
            justifyItems="center"
            width="100%"
            display="flex"
            as="section"
            rowGap="30px"
            flexDir={{
              xs: 'column',
              md: 'row',
            }}
          >
            <Flex flexDir="column" rowGap="16px">
              <Heading
                color="white"
                fontSize={{ xs: '36px', sm: '42px', lg: '64px' }}
                fontWeight="800"
                lineHeight={{ xs: '35px', lg: '83px' }}
              >
                #TheContext
              </Heading>
            </Flex>
            <Box
              w="1.5px"
              h={{ xs: '100%' }}
              bgColor="white"
              display={{ xs: 'none', md: 'block' }}
            />
            <Box
              w={{ xs: '70%', sm: '60%' }}
              h="1.5px"
              bgColor="white"
              display={{ xs: 'block', md: 'none' }}
            />
            {/*  */}
            <Heading
              as="h1"
              mb={{ xs: '10px', md: '20px' }}
              variant="reportCardTitle"
              fontSize={{ xs: '27px', sm: '29px', md: '32px', lg: '38px' }}
              color="white"
              lineHeight={{ xs: '36px', sm: '40px', md: '46px', lg: '62px' }}
            >
              A deep dive into India's alternative investment landscape -
              Exploring the CAT III funds ecosystem
            </Heading>
          </Flex>
        </Container>
      </Flex>
      <Container
        as="section"
        maxW="container.xl"
        pb="80px"
        pt="40px"
        minH="420px"
        display={{ xs: 'flex', md: 'inherit' }}
        flexDirection="column"
      >
        <Box
          float={{ xs: 'right', md: 'left' }}
          alignSelf={{ xs: 'center', md: 'flex-start' }}
          mx={{ xs: '0px', md: '0px' }}
          mr={{ xs: '0px', md: '40px', lg: '60px', xl: '40px' }}
          mb="20px"
        >
          <Flex
            flexDir={{
              xs: 'column',
              md: 'row',
            }}
            gap="20px"
            alignItems={{
              xs: 'center',
              md: 'unset',
            }}
          >
            <Img
              src="https://static.levocdn.com/WGLBUT82/UditSureka-KQ5qQqA8lyVK.jpeg"
              alt="Udit Sureka
"
              width="250px"
              height="250px"
              objectFit="cover"
              borderRadius="50%"
            />
            <Flex direction="column">
              <Heading
                as="h1"
                fontWeight="800"
                pt="20px"
                variant="reportCardTitle"
                fontSize={{ xs: '16px', md: '18px', lg: '20px' }}
                textAlign={{
                  xs: 'center',
                  md: 'left',
                }}
              >
                Udit Sureka
                <Link
                  href="https://www.linkedin.com/in/uditsureka/"
                  target="_blank"
                  display={{ xs: 'inline-block', md: 'none' }}
                  pl="10px"
                >
                  <IconButton
                    aria-label="linkedin"
                    icon={<FaLinkedin size="28px" color="#067acc" />}
                    variant="unstyled"
                    cursor="pointer"
                  />
                </Link>
              </Heading>
              <Text
                color="text.mediumBlack"
                maxW={{
                  xs: '100%',
                  md: '120px',
                }}
                w="100%"
                fontSize="16px"
                lineHeight="22px"
                fontStyle="italic"
                textAlign={{
                  xs: 'center',
                  md: 'left',
                }}
              >
                EVP & Head of Products, Nuvama Asset Services
              </Text>

              <Link
                href="https://www.linkedin.com/in/uditsureka/"
                target="_blank"
                display={{
                  xs: 'none',
                  md: 'block',
                }}
              >
                <IconButton
                  aria-label="linkedin"
                  icon={<FaLinkedin size="28px" color="#067acc" />}
                  variant="unstyled"
                  cursor="pointer"
                />
              </Link>
            </Flex>
          </Flex>
        </Box>
        <Box>
          <Box mt="16px" mb="20px">
            <Text variant="blogAnswer">
              India’s Alternative Investment Fund (AIF) industry has witnessed
              transformative growth over the past few years, cementing its
              position as a pivotal pillar in the country’s financial ecosystem.
              By September 2024, data from SEBI indicated that the AIF sector
              had achieved an impressive, committed corpus of ~INR 12 trillion.
              This extraordinary milestone reflects a compound annual growth
              rate (CAGR) of approximately ~32% over the preceding three years.
              Such robust expansion underscores the increasing appeal of
              alternative investment avenues among sophisticated investors
              seeking high-yield opportunities. <br /> <br />
              This rapid proliferation of AIFs has been fuelled by a confluence
              of factors—rising wealth in India, the nuanced investment needs of
              high-net-worth individuals, and a regulatory environment that has
              actively encouraged innovation while safeguarding investor
              interests. Among the three categories of AIFs, Category III (CAT
              III) funds have emerged as a key driver of growth, capturing the
              attention of investors and fund managers alike due to their
              flexibility and innovative strategies.
            </Text>
          </Box>
          {/* 1 */}
          <Box my="40px">
            <Text variant="blogAnswer" fontWeight="800">
              Decoding the remarkable growth of CAT III funds
            </Text>

            <Text variant="blogAnswer" mt="16px">
              CAT III funds represent a unique class of AIFs, leveraging complex
              trading strategies that may include long only, long-short,
              absolute return, and arbitrage. These funds aim to deliver
              superior absolute returns, making them an attractive option for
              investors seeking diversification and downside protection. The
              growth trajectory of CAT III funds has been nothing short of
              exceptional. In the past year alone, commitments to this category
              surged by an extraordinary 77%, far outpacing the growth rates of
              25% and 21% recorded by Category II and Category I funds,
              respectively. Notably, investments by CAT III funds have reached
              an impressive 111% of their raised capital, showcasing their
              ability to efficiently deploy reserves and optimize market
              opportunities. Industry projections remain bullish, with
              commitments to CAT III funds expected to reach approximately INR
              2.5 lakh crore by 2028. Such optimism stems from the segment’s
              innovative approach to investment, bolstered by enabling
              regulations and increasing investor confidence.
            </Text>
          </Box>
          {/* 2 */}
          <Box my="40px">
            <Text variant="blogAnswer" fontWeight="800">
              Rise of quantitative strategies
            </Text>

            <Text variant="blogAnswer" mt="16px">
              Among the diverse strategies employed by CAT III funds,
              quantitative (quant) strategies have emerged as a transformative
              force, redefining the investment landscape. These strategies rely
              on advanced algorithms, mathematical models, and data analytics to
              identify market inefficiencies and generate alpha. By eschewing
              traditional methods often influenced by emotional biases,
              quant-based funds provide a disciplined, data-driven approach to
              investing. Globally, quant funds have achieved remarkable
              dominance, with the top five hedge funds operating on quant-driven
              methodologies. In 2024, the global quant fund market was valued at
              approximately USD 16 trillion and is projected to grow at a CAGR
              of around 10.1% over the next seven years. India, though still in
              the early stages of adopting this approach, has demonstrated
              significant potential. Currently, only 1.5% of assets under
              management (AUM) in India’s investment landscape (including mutual
              funds, PMS, and AIFs) are managed using quant strategies, compared
              to 35% in the United States. However, the AUM of Indian quant
              mutual funds has grown exponentially—from INR 3 billion in 2013 to
              nearly INR 914 billion in 2024—representing a staggering CAGR of
              approximately 86% over the past three years.
            </Text>
          </Box>
          {/* 3 */}
          <Box my="40px">
            <Text variant="blogAnswer" fontWeight="800">
              Why quant funds are gaining traction
            </Text>

            <Text variant="blogAnswer" mt="16px">
              Quant-based funds offer several distinct advantages, particularly
              in today’s volatile and sentiment-driven markets:
            </Text>
            <Box mt="16px">
              <UnorderedList>
                <ListItem>
                  <Text as="span" variant="blogAnswer">
                    <strong>Precision:</strong> Advanced algorithms enable a
                    rigorous and repeatable investment process, ensuring
                    decisions are based on data rather than intuition.
                  </Text>
                </ListItem>
                <br />
                <ListItem>
                  <Text as="span" variant="blogAnswer">
                    <strong>Objectivity:</strong> Statistical methods minimize
                    the influence of personal biases, enhancing the reliability
                    of investment strategies.
                  </Text>
                </ListItem>
                <br />
                <ListItem>
                  <Text as="span" variant="blogAnswer">
                    <strong>Scalability:</strong> These strategies can
                    efficiently process vast datasets, making them adaptable to
                    varying portfolio sizes and complexities.
                  </Text>
                </ListItem>
                <br />
              </UnorderedList>
            </Box>
            <Text variant="blogAnswer">
              Investors are increasingly drawn to quant funds for their ability
              to provide uncorrelated, complementary sources of returns, making
              them a valuable addition to diversified portfolios.
            </Text>
          </Box>

          <Box my="40px">
            <Text variant="blogAnswer" fontWeight="800">
              A promising future for CAT III funds
            </Text>

            <Text variant="blogAnswer" mt="16px">
              As India's investment landscape evolves, CAT III AIFs are emerging
              as a crucial avenue for high-net-worth investors, offering a blend
              of innovation, performance, and regulatory support for long-term
              growth. The depth of CAT III funds in the AIF market is expected
              to expand as more fund managers embrace entrepreneurship, bringing
              in diverse and sophisticated strategies that enrich the industry.
              Additionally, these funds have the largest possible arsenal of
              investment opportunities available to any pooling vehicle in
              India. They can deploy capital across multiple asset
              classes—including cash, equities, fixed income, commodities and FX
              - both spot and derivatives, listed and unlisted, leveraged or
              otherwise. This flexibility enables fund managers to create
              strategies catering to investors’ needs across various spectrums –
              risk, liquidity, duration, asset class mix. For both investors and
              fund managers, CAT III funds present abundant opportunities,
              making them a dynamic and integral part of India’s alternative
              investment ecosystem.
            </Text>
          </Box>

          {/* 3  */}
        </Box>

        <Box width="100%" height="2px" bgColor="primary.200" />
        <Text
          variant="blogAnswer"
          lineHeight="30px"
          pt="18px"
          fontStyle="italic"
          p="12px 12px 0px"
          fontWeight="500"
        >
          <Text as="span" fontWeight="700" fontStyle="normal">
            #TheContext by IVCA
          </Text>{' '}
          – features opinion makers from the alternate investing industry with
          strong focus on India as an investment destination. Watch this space
          for new announcements in the sector, viewpoints on investment themes,
          emerging trends, economic reports, analysis and latest industry
          insights.
        </Text>
        <Heading
          variant="blogQuestion"
          lineHeight="30px"
          pt="16px"
          fontStyle="italic"
          p="12px 12px 0px"
        >
          Content in this section is curated by team IVCA. To share feedback,
          connect with&nbsp;
          {/* The content in this section is curated by Team IVCA. For any feedback,
          connect with&nbsp; */}
          <Link
            href="mailto:paromita.sinha@ivca.in"
            target="_blank"
            style={{ color: 'blue', textDecoration: 'underline' }}
          >
            paromita.sinha@ivca.in
          </Link>
        </Heading>
      </Container>
    </>
  );
};

export default TheContextFundEcosystemBlog;
